<template>
  <footer class="app-footer">
    <b-container>
      <b-row align-v="center">
        <b-col>
          <small class="text-muted text-uppercase">
            &copy; {{currentYear}} Victory Garage
          </small>
        </b-col>
        <b-col class="text-right">
          <div class="poweredBy">
            <small class="text-muted text-uppercase">Powered by</small>&nbsp;
            <a href="https://www.threls.com" class="threls-icon" target="_blank">
              <threls-icon class="threls-icon"/>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  computed: {
    currentYear () {
      let d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
<style scoped lang="scss">
  .threls-icon {
    display: inline;
    width: auto;
    height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue